import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
// services
import { MessageService } from '../../../../services/message.service';
import { MasterService } from '../../../../services/master.service';
import { StoreService } from '../../../../services/store.service';
import * as words from '../../../../services/language'

import { GpsDevice } from 'src/app/models/gps-device.model';
import { ago } from 'src/app/utils/date';

@Component({
    selector: 'gps-devices',
    templateUrl: './gps-devices.component.html',
    styleUrls: ['./gps-devices.component.scss'],
    standalone: false
})
export class GpsDevices implements OnInit, OnChanges {
    /*
    * variables
    */
    
    // The contact whose gps devices will be listed.
    @Input() contactId: number = 0

    // The sale whose gps devices will be listed.
    @Input() saleId: number = 0

    // The vehicle whose gps devices will be listed.
    @Input() vehicleId: number = 0
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    // A list of gps devices for the given vehicle.
    protected devices: Array<GpsDevice> = []
    
    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        this.reset()
        this.fetch()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.contactId || changes.saleId || changes.vehicleId) {
            this.reset()
            this.fetch()
        }
    }
    
    /*
    * functions
    */

    /**
     * 
     * @param e 
     */
    protected cancel = (e: Event): void => {
        e.stopPropagation()
        e.preventDefault()

        this.reset()
    }

    /*
    * Reset the devices array
    */
    private reset = (): void => {
        this.devices = null
    }

    /**
     * 
     */
    private fetch() {
        if (this.loading) {
            return
        }

        this.devices = null
        this.devices = []

        if (this.vehicleId && (this.vehicleId > 0)) {
            this.fetchVehicleDevices()
            return
        }

        if (this.saleId && (this.saleId > 0)) {
            this.fetchSaleDevices()
            return
        }

        this.fetchContactDevices()
    }

    private fetchVehicleDevices = () => {
        if (!this.vehicleId || (this.vehicleId <= 0)) {
            return
        }

        this.loading = true
        this.master.get(`vehicles/${this.vehicleId}/gps`, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.devices = res.data.gpsDevices          
        })
    }

    private fetchSaleDevices = () => {
        if (!this.saleId || (this.saleId <= 0)) {
            return
        }

        this.loading = true
        this.master.get(`sales/${this.saleId}/gps`, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.devices = res.data.gpsDevices          
        })
    }

    private fetchContactDevices = () => {
        if (!this.contactId || (this.contactId <= 0)) {
            return
        }

        this.loading = true
        this.master.get(`contacts/${this.contactId}/gps`, (res) => {
            this.loading = false
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.devices = res.data.gpsDevices          
        })
    }

    protected selected = (e: Event, device) => {

    }

    protected locate = (e: Event, device) => {
        e.stopPropagation()
        e.preventDefault()
    }

    /**
     * Return a color class to use when the device is about to or has expired.
     * @param expires The expiration date of the gps device
     */
    protected expiryClass = (expires): string => {
        if (!expires) {
            return 'text-muted'
        }

        const result = ago(expires)
        switch (result) {
            case 'soon':
                return 'text-warning'
            case 'today':
            case 'past':
                return 'text-danger'
            default:
                return 'text-muted'
        }
    }
}
